import {Controller} from 'stimulus'

export default class extends Controller {
    disable(event) {
        setTimeout(() => {  event.target.setAttribute('disabled', true); }, 20);
    }
}
